import { useAntdMessage } from "hooks/useAntdMessage";
import { usePatchMSScheduleTags } from "queries/meetingSchedule";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MeetingTagSelect from "./MeetingTagSelect";

/**
 * Editor tags pada detail jadwal: menampilkan tags berwarna + bisa tambah/hapus,
 * langsung tersimpan via PATCH /WA/meetingSchedules/{id}/tags.
 */
const MeetingTagEditor = ({ scheduleId, tags }) => {
  const { t } = useTranslation();
  const { message } = useAntdMessage();
  const patchMutation = usePatchMSScheduleTags();
  const [selected, setSelected] = useState(() =>
    (tags || []).map((tg) => tg.id)
  );

  useEffect(() => {
    setSelected((tags || []).map((tg) => tg.id));
  }, [tags, scheduleId]);

  const handleChange = (ids) => {
    setSelected(ids);
    if (!scheduleId) return;
    patchMutation.mutate(
      { id: scheduleId, tag_ids: ids },
      {
        onError: (err) => {
          message.error(
            err?.response?.data?.message ||
              t("meeting_management.tags_update_failed")
          );
        },
      }
    );
  };

  return (
    <MeetingTagSelect
      value={selected}
      onChange={handleChange}
      placeholder={t("meeting_management.add_tags")}
      disabled={patchMutation.isPending}
      style={{ width: "100%" }}
    />
  );
};

export default MeetingTagEditor;
